import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Object from './components/Standard_Nfa_Question';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, locations, states}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute path={`${match.url}`}>
				<Object baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
